module.exports = __webpack_public_path__ + "static/img/marcus_pictgrid43_960x862.0e2b527.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marcus_pictgrid43_960x862.jpg
// module id = /Sn/
// module chunks = 0